import React from "react";

import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";

// Material Dashboard 2 PRO React base styles
import typography from "../../assets/theme/base/typography";
import MDTypography from "../MDTypography";
import MDBox from "../MDBox";

export default function Footer({ ...props }) {
    const { white, contacto } = props;
    const { size } = typography;

    let links = [];

    //if (contacto != null && !contacto) {
        links.push({ href: "https://atmovilidad.com/contacto/", name: "Contacto" });
    //}
    links.push({ href: "https://atmovilidad.com/politica-de-privacidad/", name: "Pol\u00EDtica de Privacidad" });
    
    //links.push({ href: "cookies", name: "Cookies" });
    //links.push({ href: "terms", name: "Aviso Legal" });

    const renderLinks = () =>
        links.map((link) => (
            <MDBox key={link.name} component="li" px={2} lineHeight={1}>
                <Link href={link.href} target="_blank">
                    <MDTypography variant="button" fontWeight="regular" color="text" fontSize={size.sm}>
                        {link.name}
                    </MDTypography>
                </Link>
            </MDBox>
        ));

    return (
        <MDBox
            width="100%"
            display="flex"
            flexDirection={{ xs: "column", lg: "row" }}
            justifyContent="space-between"
            alignItems="center"
            px={0.5}
        >
            <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexWrap="wrap"
                color="text"
                fontSize={size.sm}
                px={0.5}
            >
                &copy; {new Date().getFullYear()} by                                
                <Link href={"https://atmovilidad.com/"} target="_blank">
                    <MDTypography variant="button" fontWeight="medium" color="info" fontSize={size.sm}>
                        &nbsp;{"Aplicaciones Turisticas en Movilidad"}&nbsp;
                    </MDTypography>
                </Link>
            </MDBox>
            <MDBox
                component="ul"
                sx={({ breakpoints }) => ({
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "center",
                    listStyle: "none",
                    mt: 3,
                    mb: 0,
                    p: 0,

                    [breakpoints.up("lg")]: {
                        mt: 0,
                    },
                })}
            >
                {renderLinks()}
            </MDBox>
        </MDBox>
    );
}
Footer.propTypes = {

    contacto: PropTypes.bool,
    white: PropTypes.bool,
};